import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateLayerFailure,
  CreateLayerRequest,
  CreateLayerSuccess,
  DeleteLayerFailure,
  DeleteLayerRequest,
  DeleteLayerSuccess,
  FetchLayerFailure,
  FetchLayerRequest,
  FetchLayerSuccess,
  FetchLayersFailure,
  FetchLayersRequest,
  FetchLayersSuccess,
  UpdateLayerFailure,
  UpdateLayerRequest,
  UpdateLayerSuccess,
  UploadLayerFileFailure,
  UploadLayerFileRequest,
  UploadLayerFileSuccess,
} from './layer.actions'
import { LayerService } from './layer.service'
import * as Wards from './layer.types'

@Injectable()
export class LayerEffects {
  constructor(
    private actions: Actions,
    private layerService: LayerService,
    private router: Router,
  ) {}

  FetchLayers$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.FETCH_LAYERS_REQUEST),
      switchMap((action: FetchLayersRequest) => {
        return this.layerService.fetchLayers(action.payload).pipe(
          map((result) => {
            return new FetchLayersSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchLayersFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchLayer$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.FETCH_LAYER_REQUEST),
      switchMap((action: FetchLayerRequest) => {
        return this.layerService.fetchLayer(action.id).pipe(
          map((result) => {
            return new FetchLayerSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchLayerFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteLayer$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.DELETE_LAYER_REQUEST),
      switchMap((action: DeleteLayerRequest) => {
        return this.layerService.deleteLayer(action.id).pipe(
          switchMap(() => {
            return [new DeleteLayerSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteLayerFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateLayer$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.CREATE_LAYER_REQUEST),
      switchMap((action: CreateLayerRequest) => {
        return this.layerService.createLayer(action.payload).pipe(
          switchMap((res) => {
            this.router.navigate(['/admin/layer', res.data.id, 'update'])
            return [new CreateLayerSuccess()]
          }),
          catchError(() => {
            return of(new CreateLayerFailure({}))
          }),
        )
      }),
    ),
  )

  UpdateLayer$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.UPDATE_LAYER_REQUEST),
      switchMap((action: UpdateLayerRequest) => {
        return this.layerService.updateLayer(action.id, action.payload).pipe(
          switchMap((response) => {
            // this.router.navigate(['/admin/layer'])
            return [new UpdateLayerSuccess()]
          }),
          catchError(() => {
            return of(new UpdateLayerFailure({}))
          }),
        )
      }),
    ),
  )

  UploadLayerFile$ = createEffect(() =>
    this.actions.pipe(
      ofType(Wards.UPLOAD_LAYER_FILE_REQUEST),
      switchMap((action: UploadLayerFileRequest) => {
        return this.layerService
          .uploadLayerFile(action.id, action.payload)
          .pipe(
            switchMap((res: any) => {
              return [new UploadLayerFileSuccess(res.data)]
            }),
            catchError(() => {
              return of(new UploadLayerFileFailure({}))
            }),
          )
      }),
    ),
  )
}
